// extracted by mini-css-extract-plugin
module.exports = {"navbar-buttons":"_3csUHu1TDbbCaRs_ORHxZw","left-nav":"_11TCLGbmAlTKXVM4QJj9k6","right-nav":"_38R7SJgG4fJ86m-eLYYZJw"};